import {isCordova} from "../../../../app";

/**
 * Gets action identification based of action key and timestamp
 * @param {string} actionKey - action key
 * @return {string} action identification
 */
function getActionId(actionKey) {
  return actionKey + Date.now();
}

/**
 * Gets basic configuration for local notifications
 * @param {{firstname: string, lastname: string, imgUrl: string}} sender - notification sender
 * @param {string} title - notification title
 * @return {{title: string, icon: string, foreground: boolean, wakeup: boolean, vibrate: boolean, sound: boolean}} basic config
 */
function getBasic(sender, title = '') {
  return {
    title: `${sender.firstname} ${sender.lastname} ${title}`,
    icon: `file://${sender.imgUrl}`,
    foreground: true,
    wakeup: true,
    vibrate: true,
    sound: false
  };
}

/**
 * Sends a local notification after video call was started
 * @param {{firstname: string, lastname: string, imgUrl: string}} sender - notification sender
 * @param {function} onStop - acts on stop
 * @return {void}
 */
export function videoStarted(sender, onStop) {
  if (isCordova()) {
    const stopId = getActionId('video_stop');

    cordova.plugins.notification.local.schedule({
      ...getBasic(sender),
      text: __("Video call started"),
      actions: [
        {
          id: stopId,
          title: __("End a call")
        }
      ]
    });
    cordova.plugins.notification.local.on(stopId, onStop);
  }
}

/**
 * Sends a local notification on incoming video call
 * @param {{firstname: string, lastname: string, imgUrl: string}} sender - notification sender
 * @param {string} title - notification title
 * @param {function} onAccept - acts on accept
 * @param {function} onDecline - acts on decline
 * @returns {void}
 */
export function videoIncoming(sender, title, onAccept, onDecline) {

  if (isCordova()) {
    const acceptId = getActionId('video_accept');
    const declineId = getActionId('video_decline');

    cordova.plugins.notification.local.schedule({
      ...getBasic(sender, title),
      actions: [
        {
          id: acceptId,
          title: "Accept"
        }, {
          id: declineId,
          title: "Decline"
        }
      ]
    });
    cordova.plugins.notification.local.on(acceptId, onAccept);
    cordova.plugins.notification.local.on(declineId, onDecline);
  }
}
